module.exports = __webpack_public_path__ + "media/images/undraw-terms-accepted-at-caf0a801ab2905a9798c2cb8892d44b8.png";